import { Link } from "react-router-dom";
import checkLogo from "../../assets/images/circle-check.svg";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";

const ResetPWSuccessUI = () => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      <div className="mb-4 d-flex justify-content-center">
        <img
          src={checkLogo}
          alt={t("auth.resetPassword.successAlt")}
          width={96}
          height={96}
        />
      </div>

      <div className="mb-4">
        <h3 className="text-primary fw-semibold mb-2 auth-form-heading">
          {t("auth.resetPassword.successTitle")}
        </h3>
        <p className="text-muted mb-0 auth-form-subheading">
          {t("auth.resetPassword.successText")}
        </p>
      </div>

      <Link to="/login">
        <Button color="primary" className="w-100 fw-semibold auth-form-button">
          {t("auth.actions.signIn")}
        </Button>
      </Link>
    </div>
  );
};

export default ResetPWSuccessUI;
